import React from 'react';
import { AVERAGE_UNAVAILABLE } from '../averages';
import type { KpiFormProps, KpiRateWindow } from '../types';
import { BoxedTileRow } from './boxed-tile-row';
import { COUNT_AVERAGE_DIGITS, figureTile, FigureUnit } from './tile-figure';

/** A window that could not be read renders like the trio's own "Date N/A",
 * distinct from a window that WAS read but carries a null rate: that one
 * reads the empty-rate label instead. Both are `figureTile`'s own branches. */
const windowTile = (
    window: KpiRateWindow | typeof AVERAGE_UNAVAILABLE,
    unit: FigureUnit,
    fromOne?: { maximumFractionDigits?: number }
) =>
    figureTile(
        window === AVERAGE_UNAVAILABLE ? window : window.rate,
        unit,
        fromOne
    );

export const RateTrioForm: React.FC<KpiFormProps> = ({ data }) => {
    if (data.form !== 'rate-trio') return null;

    const unit = { isCurrency: data.isCurrency, isPercent: data.isPercent };

    return (
        <BoxedTileRow
            highlightIndex={0}
            tiles={[
                // One digit rule on all three, unlike `trio`: these are one
                // ratio over three windows, not a total beside its averages.
                // A tile under 1 still takes `digitsFor`'s significant digits.
                {
                    title: 'Total to date',
                    ...windowTile(data.toDate, unit, COUNT_AVERAGE_DIGITS),
                },
                {
                    title: 'Weekly avg.',
                    ...windowTile(data.weekly, unit, COUNT_AVERAGE_DIGITS),
                },
                {
                    title: 'Daily avg.',
                    ...windowTile(data.daily, unit, COUNT_AVERAGE_DIGITS),
                },
            ]}
        />
    );
};
